app.registerLib('data', function(app) {

	var helpers = app.helpers.funcs;

	return {
		data: {},

		set: function (key, d) {
			helpers.arraySet(this.data, key, d);
		},

		setIfNotSet: function (key, d) {
		    helpers.arraySetIfNotSet(this.data, key, d);
		},

		get: function (key, def) {
			return helpers.arrayGet(this.data, key, def);
		}
	};

});